import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    authControllerLogoutV1: build.mutation<
      AuthControllerLogoutV1ApiResponse,
      AuthControllerLogoutV1ApiArg
    >({
      query: () => ({ url: `/api/v1/auth/logout`, method: 'POST' }),
    }),
    authControllerRevokeTokensV1: build.mutation<
      AuthControllerRevokeTokensV1ApiResponse,
      AuthControllerRevokeTokensV1ApiArg
    >({
      query: () => ({ url: `/api/v1/auth/revoke-tokens`, method: 'POST' }),
    }),
    jwtRefreshControllerRefreshTokenV1: build.mutation<
      JwtRefreshControllerRefreshTokenV1ApiResponse,
      JwtRefreshControllerRefreshTokenV1ApiArg
    >({
      query: () => ({ url: `/api/v1/auth/refresh-token`, method: 'POST' }),
    }),
    localControllerLoginV1: build.mutation<
      LocalControllerLoginV1ApiResponse,
      LocalControllerLoginV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/auth/login`,
        method: 'POST',
        body: queryArg.loginBody,
      }),
    }),
    localControllerRegisterV1: build.mutation<
      LocalControllerRegisterV1ApiResponse,
      LocalControllerRegisterV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/auth/register`,
        method: 'POST',
        body: queryArg.registerBody,
      }),
    }),
    emailConfirmationControllerConfirmEmailV1: build.mutation<
      EmailConfirmationControllerConfirmEmailV1ApiResponse,
      EmailConfirmationControllerConfirmEmailV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/email/confirm-email`,
        method: 'POST',
        body: queryArg.confirmEmailBody,
      }),
    }),
    emailConfirmationControllerResendConfirmationLinkV1: build.mutation<
      EmailConfirmationControllerResendConfirmationLinkV1ApiResponse,
      EmailConfirmationControllerResendConfirmationLinkV1ApiArg
    >({
      query: () => ({
        url: `/api/v1/email/resend-confirmation-link`,
        method: 'POST',
      }),
    }),
    mfaControllerGenerateQrV1: build.mutation<
      MfaControllerGenerateQrV1ApiResponse,
      MfaControllerGenerateQrV1ApiArg
    >({
      query: () => ({ url: `/api/v1/mfa/generate`, method: 'POST' }),
    }),
    mfaControllerEnableMfaV1: build.mutation<
      MfaControllerEnableMfaV1ApiResponse,
      MfaControllerEnableMfaV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/mfa/verify`,
        method: 'POST',
        body: queryArg.enableMfaBody,
      }),
    }),
    mfaControllerAuthenticateMfaV1: build.mutation<
      MfaControllerAuthenticateMfaV1ApiResponse,
      MfaControllerAuthenticateMfaV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/mfa/authenticate`,
        method: 'POST',
        body: queryArg.authenticateMfaBody,
      }),
    }),
    mfaControllerResetMfaV1: build.mutation<
      MfaControllerResetMfaV1ApiResponse,
      MfaControllerResetMfaV1ApiArg
    >({
      query: () => ({ url: `/api/v1/mfa/reset`, method: 'POST' }),
    }),
    mfaRecoveryCodeControllerRecoverMfaV1: build.mutation<
      MfaRecoveryCodeControllerRecoverMfaV1ApiResponse,
      MfaRecoveryCodeControllerRecoverMfaV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/mfa/recover`,
        method: 'POST',
        body: queryArg.recoverMfaBody,
      }),
    }),
    resetPasswordControllerSendResetPasswordEmailV1: build.mutation<
      ResetPasswordControllerSendResetPasswordEmailV1ApiResponse,
      ResetPasswordControllerSendResetPasswordEmailV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/password`,
        method: 'POST',
        body: queryArg.sendResetPasswordEmailBody,
      }),
    }),
    resetPasswordControllerResetPasswordV1: build.mutation<
      ResetPasswordControllerResetPasswordV1ApiResponse,
      ResetPasswordControllerResetPasswordV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/password`,
        method: 'PUT',
        body: queryArg.resetPasswordBody,
      }),
    }),
    resetPasswordControllerGetResetPasswordSessionV1: build.query<
      ResetPasswordControllerGetResetPasswordSessionV1ApiResponse,
      ResetPasswordControllerGetResetPasswordSessionV1ApiArg
    >({
      query: () => ({ url: `/api/v1/password/session` }),
    }),
    resetPasswordControllerVerifyResetPasswordEmailV1: build.mutation<
      ResetPasswordControllerVerifyResetPasswordEmailV1ApiResponse,
      ResetPasswordControllerVerifyResetPasswordEmailV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/password/verify-email`,
        method: 'POST',
        body: queryArg.verifyResetPasswordEmailBody,
      }),
    }),
    resetPasswordControllerVerifyResetPasswordMfaV1: build.mutation<
      ResetPasswordControllerVerifyResetPasswordMfaV1ApiResponse,
      ResetPasswordControllerVerifyResetPasswordMfaV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/password/verify-2fa`,
        method: 'POST',
        body: queryArg.verifyResetPasswordMfaBody,
      }),
    }),
    resetPasswordControllerVerifyResetPasswordRecoveryCodeV1: build.mutation<
      ResetPasswordControllerVerifyResetPasswordRecoveryCodeV1ApiResponse,
      ResetPasswordControllerVerifyResetPasswordRecoveryCodeV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/password/verify-recovery-code`,
        method: 'POST',
        body: queryArg.verifyResetPasswordRecoveryCodeBody,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type AuthControllerLogoutV1ApiResponse = unknown;
export type AuthControllerLogoutV1ApiArg = void;
export type AuthControllerRevokeTokensV1ApiResponse = unknown;
export type AuthControllerRevokeTokensV1ApiArg = void;
export type JwtRefreshControllerRefreshTokenV1ApiResponse =
  /** status 200 Returns a new JWT access token */ RefreshTokenResponse;
export type JwtRefreshControllerRefreshTokenV1ApiArg = void;
export type LocalControllerLoginV1ApiResponse =
  /** status 200 Returns access token */ LoginResponse;
export type LocalControllerLoginV1ApiArg = {
  loginBody: LoginBody;
};
export type LocalControllerRegisterV1ApiResponse =
  /** status 200 Returns access token */ RegisterResponse;
export type LocalControllerRegisterV1ApiArg = {
  registerBody: RegisterBody;
};
export type EmailConfirmationControllerConfirmEmailV1ApiResponse =
  /** status 200 Updates user profile status to email confirmed */ ConfirmEmailResponse;
export type EmailConfirmationControllerConfirmEmailV1ApiArg = {
  confirmEmailBody: ConfirmEmailBody;
};
export type EmailConfirmationControllerResendConfirmationLinkV1ApiResponse =
  /** status 200 Sends an email with a verification code to confirm the email address */ ResendConfirmationLinkResponse;
export type EmailConfirmationControllerResendConfirmationLinkV1ApiArg = void;
export type MfaControllerGenerateQrV1ApiResponse = unknown;
export type MfaControllerGenerateQrV1ApiArg = void;
export type MfaControllerEnableMfaV1ApiResponse =
  /** status 200 Updates user profile status to active (with both email address confirmed and MFA enabled), generates recovery codes and login the user */ EnableMfaResponse;
export type MfaControllerEnableMfaV1ApiArg = {
  enableMfaBody: EnableMfaBody;
};
export type MfaControllerAuthenticateMfaV1ApiResponse =
  /** status 200 Returns access and refresh tokens after MFA authentication */ AuthenticateMfaResponse;
export type MfaControllerAuthenticateMfaV1ApiArg = {
  authenticateMfaBody: AuthenticateMfaBody;
};
export type MfaControllerResetMfaV1ApiResponse =
  /** status 200 Reset user profile status to pending MFA and login the user */ ResetMfaResponse;
export type MfaControllerResetMfaV1ApiArg = void;
export type MfaRecoveryCodeControllerRecoverMfaV1ApiResponse =
  /** status 200 Returns access token after MFA authentication only (no refresh token!) so on UI it should ask a user to reset 2FA after this action */ RecoverMfaResponse;
export type MfaRecoveryCodeControllerRecoverMfaV1ApiArg = {
  recoverMfaBody: RecoverMfaBody;
};
export type ResetPasswordControllerSendResetPasswordEmailV1ApiResponse =
  /** status 200 Sets the reset session cookie and emails the code */ SendResetPasswordEmailResponse;
export type ResetPasswordControllerSendResetPasswordEmailV1ApiArg = {
  sendResetPasswordEmailBody: SendResetPasswordEmailBody;
};
export type ResetPasswordControllerResetPasswordV1ApiResponse =
  /** status 200 Updates the password */ ResetPasswordResponse;
export type ResetPasswordControllerResetPasswordV1ApiArg = {
  resetPasswordBody: ResetPasswordBody;
};
export type ResetPasswordControllerGetResetPasswordSessionV1ApiResponse =
  /** status 200 The reset session progress */ GetResetPasswordSessionResponse;
export type ResetPasswordControllerGetResetPasswordSessionV1ApiArg = void;
export type ResetPasswordControllerVerifyResetPasswordEmailV1ApiResponse =
  /** status 200 Marks the email of the reset session as verified */ VerifyResetPasswordEmailResponse;
export type ResetPasswordControllerVerifyResetPasswordEmailV1ApiArg = {
  verifyResetPasswordEmailBody: VerifyResetPasswordEmailBody;
};
export type ResetPasswordControllerVerifyResetPasswordMfaV1ApiResponse =
  /** status 200 Marks the second factor of the reset session as passed */ VerifyResetPasswordMfaResponse;
export type ResetPasswordControllerVerifyResetPasswordMfaV1ApiArg = {
  verifyResetPasswordMfaBody: VerifyResetPasswordMfaBody;
};
export type ResetPasswordControllerVerifyResetPasswordRecoveryCodeV1ApiResponse =
  /** status 200 Marks the second factor of the reset session as passed */ VerifyResetPasswordRecoveryCodeResponse;
export type ResetPasswordControllerVerifyResetPasswordRecoveryCodeV1ApiArg = {
  verifyResetPasswordRecoveryCodeBody: VerifyResetPasswordRecoveryCodeBody;
};
export type RefreshTokenResponse = {
  /** JWT access token */
  accessToken: string;
};
export type LoginResponse = {
  /** JWT access token */
  accessToken: string;
};
export type LoginBody = {
  /** User email address */
  email: string;
  /** User password */
  password: string;
  /** Client browser fingerprint */
  fingerprint?: string;
};
export type RegisterResponse = {
  /** JWT access token */
  accessToken: string;
};
export type RegisterBody = {
  /** Full name */
  fullname: string;
  /** Company name */
  company: string;
  referredBy: string;
  /** User email address */
  email: string;
  /** User password */
  password: string;
  /** Client browser fingerprint */
  fingerprint?: string;
};
export type ConfirmEmailResponse = {
  success: boolean;
  message?: string;
};
export type ConfirmEmailBody = {
  /** 8-digit email verification code */
  code: string;
};
export type ResendConfirmationLinkResponse = {
  success: boolean;
  message?: string;
};
export type EnableMfaResponse = {
  /** 2FA recovery codes */
  recoveryCodes: string[];
  success: boolean;
  message?: string;
  /** JWT access token */
  accessToken: string;
};
export type EnableMfaBody = {
  /** 2FA verification code */
  mfaCode: string;
  /** Client browser fingerprint */
  fingerprint?: string;
};
export type AuthenticateMfaResponse = {
  /** JWT access token */
  accessToken: string;
};
export type AuthenticateMfaBody = {
  /** 2FA verification code */
  mfaCode: string;
  /** Client browser fingerprint */
  fingerprint?: string;
};
export type ResetMfaResponse = {
  success: boolean;
  message?: string;
  /** JWT access token */
  accessToken: string;
};
export type RecoverMfaResponse = {
  success: boolean;
  message?: string;
  /** JWT access token */
  accessToken: string;
};
export type RecoverMfaBody = {
  /** 2FA recovery code */
  code: string;
};
export type SendResetPasswordEmailResponse = {
  success: boolean;
  message?: string;
};
export type SendResetPasswordEmailBody = {
  /** User email address */
  email: string;
};
export type ResetPasswordResponse = {
  success: boolean;
  message?: string;
};
export type ResetPasswordBody = {
  /** User password */
  password: string;
};
export type GetResetPasswordSessionResponse = {
  /** The email the code was sent to, masked */
  maskedEmail: string;
  /** The emailed code was entered */
  emailVerified: boolean;
  /** The user has 2FA enabled and must pass it before setting a password; null until the email is verified */
  requiresMfa: boolean | null;
  /** The second factor was passed */
  mfaVerified: boolean;
  /** When the reset session expires */
  expiresAt: string;
};
export type VerifyResetPasswordEmailResponse = {
  success: boolean;
  message?: string;
};
export type VerifyResetPasswordEmailBody = {
  /** 8-digit password reset code from the email */
  code: string;
};
export type VerifyResetPasswordMfaResponse = {
  success: boolean;
  message?: string;
};
export type VerifyResetPasswordMfaBody = {
  /** 2FA (TOTP) code from the authenticator app */
  code: string;
};
export type VerifyResetPasswordRecoveryCodeResponse = {
  success: boolean;
  message?: string;
};
export type VerifyResetPasswordRecoveryCodeBody = {
  /** 2FA recovery code */
  code: string;
};
